var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSx = function SvgSx(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#D80027",
    d: "M10.957 13.043s-7.435-9.53-7.442-9.53A11.962 11.962 0 0 1 12 0c6.627 0 12 5.373 12 12l-13.043 1.044Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0052B4",
    d: "M10.957 12s-7.435 8.486-7.442 8.485A11.963 11.963 0 0 0 12 24c6.627 0 12-5.373 12-12H10.957Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F0F0F0",
    d: "M3.515 3.515c-4.687 4.686-4.687 12.284 0 16.97L12 12 3.515 3.515Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFDA44",
    d: "M1.316 12a3.391 3.391 0 1 0 6.76 0h-6.76ZM4.696 10.434a1.044 1.044 0 1 0 0-2.087 1.044 1.044 0 0 0 0 2.087Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D80027",
    d: "M2.348 9.13v3.392c0 1.797 2.347 2.347 2.347 2.347s2.348-.55 2.348-2.347V9.13H2.348Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#338AF3",
    d: "M4.697 13.778c-.435-.157-1.305-.558-1.305-1.256v-2.348H6v2.348c0 .7-.87 1.1-1.303 1.256Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F3F3F3",
    d: "M5.217 11.478v-.522l-.521-.26-.522.26v.522l-.26.26v1.044h1.564v-1.043l-.26-.261Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))));
};
export default SvgSx;